import { atom, selector } from 'recoil'

export const pageState = atom({
  key: 'messageListPageState',
  default: {
    fetchingResults: false,
    firstLoading: true,
    downloadFile: false
  }
})

export const pageErrorState = atom({
  key: 'messageListPageErrorState',
  default: {
    error: undefined,
    severity: 'danger'
  }
})

export const loadingState = selector({
  key: 'messageListLoadingState',
  get: ({ get }) => {
    const { fetchingResults } = get(pageState)
    return [fetchingResults].some(value => value)
  }
})

export const modalSendingState = atom({
  key: 'messageListModalSendingState',
  default: false
})

export const modalMessageUsageState = atom({
  key: 'messageListModalMessageUsageState',
  default: {
    show: false,
    entityName: undefined,
    entityId: undefined,
    idMessage: undefined
  }
})

export const modalDeleteState = atom({
  key: 'messageListModalDeleteState',
  default: {
    show: false,
    items: [],
    allMessageArchived: false
  }
})

export const modalBuyCollaborationState = atom({
  key: 'messageListModalBuyCollaborationState',
  default: false
})
